import classNames from 'classnames';
import { FC } from 'react';

import { IcSecureE2ee16Icon } from '@gem/icons';
import { IconView, IconViewSizes } from '@gem/ui-kit';

import styles from './SecureChatBadge.styles.m.css';

interface ISecureChatBadgeProps {
  className?: string;
}

export const SecureChatBadge: FC<ISecureChatBadgeProps> = (props) => {
  return (
    <IconView
      className={classNames(styles.secure, props.className)}
      size={IconViewSizes.Small}
      Icon={IcSecureE2ee16Icon}
    />
  );
};
